module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "motd centered"
  }, [_c('span', {
    staticClass: "sep"
  }, [_vm._v("*====================================MOTD=====================================*")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("You can browse reddit posts and comments by using a terminal-esq interface. ")]), _vm._v(" "), _c('p', [_vm._v("Type `"), _c('span', {
    staticClass: "yellow help",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.type('help')
      }
    }
  }, [_vm._v("help")]), _vm._v("` to get a list of commands or type `"), _c('span', {
    staticClass: "yellow help",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.type('list')
      }
    }
  }, [_vm._v("list")]), _vm._v("` to get some posts")]), _vm._v(" "), _c('span', {
    staticClass: "sep"
  }, [_vm._v("*=============================================================================*")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Welcome to terminal reddit, don't let your memes be dreams."), _c('br'), _c('a', {
    staticClass: "sep",
    attrs: {
      "href": "https://github.com/hparton/terminal.reddit",
      "target": "_blank"
    }
  }, [_vm._v("Version 1.0.1")]), _vm._v(" built with Vue.js by "), _c('a', {
    staticClass: "sep",
    attrs: {
      "href": "https://twitter.com/h_parton",
      "target": "_blank"
    }
  }, [_vm._v("Harry Parton")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-153b1e66!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/responses/motd.vue
// module id = 287
// module chunks = 2